<template>
    <div class="md:px-4 px-14 md:py-4 py-8 shadow ">
      <!-- TOP SECTION -->
      <div class="continer py-4 mx-auto flex flex-row items-center justify-between md:items-start md:flex-col">
        <!-- LEFT SECTION -->

        <div class="flex flex-col">
          <h3 class="text-white font-semibold">Subscribe to our newsletter</h3>
          <div class="md:bg-red-600 flex flex-col md:flex-row rounded mt-2">
              <input type="text">
              <button type="submit" class="px-4 py-1 rounded md:py-2 text-white font-semibold mt-2 md:mt-0 bg-red-600">Subscribe</button>
          </div>
          
        </div>
        <!-- MID SECTION -->
        <div class="flex flex-col mt-8 md:mt-0">
          <p class="text-gray-200 md:text-center font-semibold">Our Media Handles</p>
          <div class="flex flex-row items-center md:justify-between mt-2">
             <a class="media bg-ash" href=""><img class="media-image" src="/img/facebook.svg" alt=""></a>
             <a class="media-link bg-ash" href=""><img class="media-image" src="/img/insta.svg" alt=""></a>
             <a class="media-link bg-ash" href=""><img class="media-image" src="/img/twitter.svg" alt=""></a>
        </div>
        </div>
        

        <!-- RIGHT SECTION -->
        <div class="md:mt-8 mt-0">
             <img class="h-4 md:h-6" src="/img/BloodHQ.svg" alt="logo" />
       
        </div>


      </div>

      <!-- BOTTON SECTION -->
      <div class="mt-8">
          <hr class="divide-gray-300">
          <img class="mt-4" src="/img/copyright.svg" alt="" style="width:12rem;">
      </div>
      
      
 
    </div>
  
</template>

<script>
import Logo from "./Logo.vue";
export default {
  name: "Navbar",
  Logo,

  data() {
    return { isOpen: false };
  },
};
</script>

<style scoped>
 hr{
   border: 0;
   height: 1px;
   background-color: white;
   opacity: 0.5;
 }
 h3{
   margin: 0;
   padding: 0;
 }

 .media-link{
   
   margin: 0 10px;
   padding: 8px;
   
 }

 .media{
   
   margin-right: 10px;
   padding: 8px;
   
 }

 .media-image{
   width: 18px;
 }

 input{
   border-radius: 0 4 8 2;
 }

 
</style>